import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { getAccessToken, getRefreshToken } from '@ecp/common/src/utils/utils';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

import UserInfoProvider from '@bo-components/common/provider/UserInfoProvider';
import SuspenseSpinner from '@bo-components/common/SuspenseSpinner';
import SsoRoutes from '../routes/SsoRoutes';
import Lnb from '@bo-layout/lnb/Lnb';
import Gnb from '@bo-layout/gnb/Gnb';
import Contents from '@bo-layout/contents/Contents';

const Home = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();

  return accessToken && refreshToken ? (
    <Container>
      <Suspense fallback={<SuspenseSpinner />}>
        <UserInfoProvider>
          <Lnb />
          <Body>
            <Gnb />
            <Contents>
              <Outlet />
            </Contents>
            <div id="contents-utility" />
          </Body>
        </UserInfoProvider>
      </Suspense>
    </Container>
  ) : (
    <SsoRoutes />
  );
};

const Container = styled(FlexBox)`
  max-width: 3880px;
  align-items: flex-start;
  overflow: hidden;
`;

const Body = styled(FlexBoxColumn)`
  flex-grow: 1;
  flex-shrink: 1;
  justify-content: flex-start;
  align-items: stretch;
  overflow: hidden;

  & > #contents-utility {
    align-self: stretch;
  }
`;

export default Home;
